<div class="flex flex-col h-full">
    <h2 mat-dialog-title>Clone Destination: {{ data.destination.ds_name }}</h2>

    <mat-dialog-content class="flex-auto overflow-y-auto">
        <form [formGroup]="cloneForm" class="space-y-6">
            <div class="flex flex-col sm:flex-row sm:items-center gap-4">
                <mat-form-field class="sm:flex-none">
                    <mat-label>How many clones?</mat-label>
                    <input matInput type="number" formControlName="count" [min]="1" (input)="updateClonesArray()">
                </mat-form-field>

                <mat-radio-group formControlName="type" aria-label="Select a clone type">
                    <mat-radio-button color="primary" value="simple" class="mr-4">Simple</mat-radio-button>
                    <mat-radio-button color="primary" value="detailed">Detailed</mat-radio-button>
                </mat-radio-group>
            </div>

            <div *ngIf="cloneForm.get('type').value === 'simple'" class="p-4 border rounded-md bg-gray-50 dark:bg-gray-800">
                <p class="text-secondary">
                    This will create {{ cloneForm.get('count').value }}
                    clone<span *ngIf="cloneForm.get('count').value > 1">s</span>
                    with the name '{{ data.destination.ds_name }} (Clone)' and the same address.
                </p>
            </div>

            <div *ngIf="cloneForm.get('type').value === 'detailed'" formArrayName="clones" class="space-y-4">
                <div *ngFor="let clone of clones.controls; let i = index" [formGroupName]="i" class="p-4 border rounded-md relative">
                    <h3 class="font-semibold mb-2">Clone {{ i + 1 }}</h3>
                    <mat-form-field class="w-full">
                        <mat-label>New Name</mat-label>
                        <input matInput formControlName="name" required>
                    </mat-form-field>
                    <mat-form-field class="w-full">
                        <mat-label>New Address</mat-label>
                        <input matInput formControlName="address">
                        <button mat-icon-button matSuffix (click)="verifyAddress(i)" [disabled]="verifying[i]" matTooltip="Verify Address">
                            <mat-progress-spinner *ngIf="verifying[i]" [diameter]="24" mode="indeterminate"></mat-progress-spinner>
                            <mat-icon *ngIf="!verifying[i]">location_on</mat-icon>
                        </button>
                    </mat-form-field>
                    <div *ngIf="verifiedData[i]" class="text-sm text-green-600 dark:text-green-400 -mt-2 mb-2 flex items-center">
                        <mat-icon class="icon-size-5 mr-1">check_circle</mat-icon>
                        <span>Verified: {{ verifiedData[i].formatted_address }}</span>
                    </div>
                </div>
            </div>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="flex-shrink-0 !pt-6">
        <button mat-stroked-button (click)="onNoClick()">Cancel</button>
        <button mat-flat-button color="primary" [disabled]="cloneForm.invalid || isCloning" (click)="executeClone()">
            <span *ngIf="!isCloning">Clone</span>
            <mat-progress-spinner *ngIf="isCloning" [diameter]="24" mode="indeterminate"></mat-progress-spinner>
        </button>
    </mat-dialog-actions>
</div>
